
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import {
  AuthPages,
  dashboardPages,
  attendancePages,
  sitePages,
  taskPages,
  drivePages,
  billPages,
  userPage,
  LeavePages,
  ESSPages,
  PayrollPages,
  TrainingPages
} from "./Pages";
import * as routes from "./routes";
import { Layout, Common } from "./Components";
import { DashboardProvider, UserContextProvider } from "./Context";
import NotFound from "./Components/Common/NotFound";
import { default as BackButtonHandler } from "./BackButtonHandler"

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          loading: {
            icon: <Common.Spinner size={4} />,
          },
        }}
      />
      <UserContextProvider>
        <BackButtonHandler />
        <Routes>
          <Route path={routes.LOGIN} element={<Layout.PublicLayout />}>
            <Route path={routes.LOGIN} element={<AuthPages.Login />} />
          </Route>
          <Route path={routes.SIGNUP} element={<Layout.PublicLayout />}>
            <Route path={routes.SIGNUP} element={<AuthPages.Signup />} />
          </Route>
          <Route path={routes.BASE} element={<Layout.Layout />}>
            <Route path={routes.BASE} element={
              <DashboardProvider>
                <dashboardPages.Dashboard />
              </DashboardProvider>
            } />
            <Route path={routes.PROFILE} element={<userPage.UserDetails />} />

            <Route
              path={routes.DRIVE}
              element={
                <Layout.UnAuthorizedRoute>
                  <drivePages.Folder />
                </Layout.UnAuthorizedRoute>
              }
            />

            <Route path={routes.SITE} element={<Layout.PrivateLayout />}>
              <Route index element={<sitePages.ListSites />} />
              <Route
                path={routes.ADD_SITE}
                element={<sitePages.SiteOperations />}
              />
              <Route
                path={routes.VIEW_SITE}
                element={<sitePages.SiteOperations />}
              />
              <Route
                path={routes.EDIT_SITE}
                element={<sitePages.SiteOperations />}
              />
            </Route>
            <Route path={routes.ATTENDANCE} element={<Layout.PrivateLayout />}>
              <Route
                path={routes.ATTENDANCE_ACTION}
                element={<attendancePages.AdminAttendanceList />}
              />
              <Route
                path={routes.ATTENDANCE_DASHBOARD_LINK}
                element={<attendancePages.ListAttendance />}
              />
              <Route
                path={routes.CHECK_IN}
                element={<attendancePages.CheckIn />}
              />
              <Route
                path={routes.CHECK_OUT}
                element={<attendancePages.CheckOut />}
              />
              <Route
                path={routes.BACK_DATED}
                element={<attendancePages.BackDated />}
              />
              <Route
                path={routes.BACKDATED_APPROVAL}
                element={<attendancePages.BackdatedPermissionList />}
              />
              <Route
                path={routes.VIEW_DETAILED_PAGE}
                element={<attendancePages.DetailedViewPage />}
              />
            </Route>
            <Route path={routes.TASK_PAGE} element={<Layout.PrivateLayout />}>
              <Route index element={<taskPages.TaskListPage />} />
              <Route path={routes.ADD_TASK} element={<taskPages.AddTask />} />
              <Route
                path={routes.VIEW_DETAILS}
                element={<taskPages.ViewDetails />}
              />
            </Route>
            <Route path={routes.LIST_BILLS} element={<Layout.PrivateLayout />}>
              <Route index element={<billPages.ViewBills />} />
              <Route
                path={routes.ADD_BILL}
                element={<billPages.BillOperations />}
              />
              <Route
                path={routes.VIEW_BILL}
                element={<billPages.BillOperations />}
              />
            </Route>
            <Route path={routes.USER_PAGE} element={<Layout.PrivateLayout />}>
              <Route index element={<userPage.UserListPage />} />
            </Route>
            <Route path={routes.EDIT_USER} element={<Layout.PrivateLayout />}>
              <Route index element={<userPage.UserDetails />} />
            </Route>
            <Route path={routes.VIEW_USER} element={<Layout.PrivateLayout />}>
              <Route index element={<userPage.UserDetails />} />
            </Route>
            <Route path={routes.LEAVE_CALENDAR} element={<Layout.PrivateLayout />} >
              <Route index element={<LeavePages.LeaveCalendar />} />
            </Route>
            <Route path={routes.LEAVE_REQUEST_LIST} element={<Layout.PrivateLayout />}>
              <Route index element={<LeavePages.LeaveRequestList />} />
              <Route path={routes.ADD_LEAVE_REQUEST} element={<LeavePages.LeaveRequestActions />} />
              <Route path={routes.VIEW_LEAVE_REQUEST} element={<LeavePages.LeaveRequestActions />} />
            </Route>
            <Route path={routes.LEAVE_APPROVALS} element={<Layout.PrivateLayout />}>
              <Route index element={<LeavePages.LeaveApprovals />} />
              <Route path={routes.VIEW_LEAVE_APPROVALS} element={<LeavePages.LeaveRequestActions />} />
            </Route>
            <Route path={routes.LEAVE_SUMMARY_LIST} element={<Layout.PrivateLayout />} >
              <Route index element={<LeavePages.LeaveSummaryList />} />
            </Route>
            <Route path={routes.LEAVE_CREDIT_DEBIT_LIST} element={<Layout.PrivateLayout />} >
              <Route index element={<LeavePages.LeaveCreditDebitList />} />
              <Route path={routes.ADD_LEAVE_CREDIT_DEBIT} element={<LeavePages.LeaveCreditDebitActions />} />
              <Route path={routes.VIEW_LEAVE_CREDIT_DEBIT} element={<LeavePages.LeaveCreditDebitActions />} />
            </Route>
            <Route path={routes.ESS} element={<ESSPages.EmpDocs />}>
            </Route>
            <Route path={routes.EMP_REFERRAL_LIST} element={<Layout.PrivateLayout />} >
              <Route index element={<ESSPages.EmployeeReferralList />} />
              <Route path={routes.ADD_EMP_REFERRAL} element={<ESSPages.EmployeeReferralActions />} />
              <Route path={routes.VIEW_EMP_REFERRAL} element={<ESSPages.EmployeeReferralActions />} />
            </Route>
            <Route
              path={routes.SALARY_MASTER}
              element={<PayrollPages.SalaryMaster />}
            >
            </Route>
            <Route
              path={routes.ADD_SALARY_MASTER}
              element={<PayrollPages.SalaryMasterAction />}
            >
            </Route>
            <Route
              path={routes.DETAIL_SALARY_MASTER}
              element={<PayrollPages.SalaryMasterAction />}
            ></Route>
            <Route
              path={routes.SALARY_SLIP}
              element={<PayrollPages.SalarySlipList />}
            >
            </Route>
            <Route
              path={routes.DETAIL_SALARY_SLIP}
              element={<PayrollPages.SalarySlipAction />}
            ></Route>
            <Route
              path={routes.EDIT_SALARY_SLIP}
              element={<PayrollPages.SalarySlipAction />}
            ></Route>
            <Route path={routes.TRAINING} element={<Layout.PrivateLayout />} >
              <Route index element={<TrainingPages.CourseListPage />} />
              <Route path={routes.CREATE_COURSE} element={<TrainingPages.CourseActionPage />} />
              <Route path={routes.EDIT_COURSE} element={<TrainingPages.CourseActionPage />} />
            </Route>
            <Route path={routes.LEARNING_COURSE} element={<TrainingPages.CourseDetailsPage/>}></Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </UserContextProvider>
    </>
  );
}

export default App;
